<template>
  <Layout>
    <div class="questionnaire-cont">
      <h3 class="title-txt">为了保证评估结果的准确性，请完善以下信息</h3>
      <el-form
        ref="ruleForm"
        :model="form"
        :rules="rules"
        class="questionnaire-form"
      >
        <el-form-item class="sex-item" label="性别">
          <el-radio v-model="form.gender" label="1">男</el-radio>
          <el-radio v-model="form.gender" label="2">女</el-radio>
        </el-form-item>
        <el-form-item label="出生年份" prop="yearOfBirth">
          <el-select
            v-model="form.yearOfBirth"
            placeholder="请选择"
            @visible-change="handleInitYear($event)"
          >
            <el-option
              v-for="item in yearlist"
              :key="item"
              :label="item"
              :value="item"
              @click="form.yearOfBirth = item"
            />
          </el-select>
        </el-form-item>
        <div class="flex-cont">
          <el-form-item label="身高" prop="height">
            <el-input
              v-model="form.height"
              type="text"
              maxlength="3"
              placeholder="请输入"
              @input="value => value.replace(/\D/gm, '')"
            >
              <template slot="append">CM</template>
            </el-input>
          </el-form-item>
          <el-form-item label="体重" prop="weight">
            <el-input
              v-model="form.weight"
              type="text"
              maxlength="3"
              placeholder="请输入"
              @input="value => value.replace(/\D/gm, '')"
            >
              <template slot="append">KG</template>
            </el-input>
          </el-form-item>
        </div>
        <el-form-item label="手机号后四位" prop="clientPhoneTailNumber">
          <el-input
            v-model="form.clientPhoneTailNumber"
            type="text"
            minlength="4"
            maxlength="4"
            placeholder="请输入"
            @input="value => value.replace(/\D/gm, '')"
          />
        </el-form-item>
        <el-form-item label="近3个月的健身频率" prop="fitnessRating">
          <el-select v-model="form.fitnessRating" placeholder="请选择">
            <el-option
              v-for="item in frequency"
              :key="item.key"
              :label="item.value"
              :value="item.value"
            />
          </el-select>
        </el-form-item>
        <el-form-item class="checkbox-item">
          <el-checkbox
            v-model="form.skipTestGuide"
          >跳过所有体测中的讲解视频</el-checkbox>
        </el-form-item>
      </el-form>
      <el-dialog
        v-if="remindVisible"
        class="remind-dialog"
        :modal="false"
        :title="remindTitle"
        :visible.sync="remindVisible"
        :before-close="handleBeforeClose"
      >
        <div class="remind-warpper">
          <div class="content-left">
            <img src="../../assets/images/warning.png">
          </div>
          <div class="content-right">{{ remindContent }}</div>
        </div>
        <span v-if="remindFlag" slot="footer" class="dialog-footer">
          <el-button @click="handleCloseRemind">退出评估</el-button>
          <el-button type="primary" @click="handleAgree">我已知晓</el-button>
        </span>
        <span v-else slot="footer" class="dialog-footer">
          <el-button
            type="primary"
            @click="handleCloseRemind"
          >退出评估</el-button>
        </span>
      </el-dialog>
      <el-button
        type="primary"
        class="submit-btn"
        :loading="submitLoading"
        @click="handleSubmit"
      >提交</el-button>
    </div>
  </Layout>
</template>

<script>
import Layout from "./components/layout.vue";
import moment from "moment";
export default {
  components: { Layout },
  data() {
    const todayYear = new Date().getFullYear();
    const yearlist = [];
    for (let i = 100 - 1; i >= 0; i--) {
      yearlist.push(todayYear - i);
    }
    return {
      submitLoading: false,
      frequency: [],
      yearlist,
      form: {
        gender: "1",
        yearOfBirth: null,
        height: null,
        weight: null,
        clientPhoneTailNumber: "",
        fitnessRating: "",
        skipTestGuide: true,
        riskConfirm: true,
      },
      rules: {
        yearOfBirth: [
          {
            required: true,
            message: "请选择年份",
            trigger: ["blur", "change"],
          },
        ],
        height: [
          { required: true, message: "请输入您的身高", trigger: "blur" },
        ],
        weight: [
          { required: true, message: "请输入您的体重", trigger: "blur" },
        ],
        clientPhoneTailNumber: [
          {
            required: true,
            validator: (rule, value, callback) => {
              if (!value) {
                callback(new Error("请输入手机号后四位"));
              } else if (value.length < 4) {
                callback(new Error("请输入手机号后四位"));
              } else {
                callback();
              }
            },
            trigger: ["blur"],
          },
        ],
        fitnessRating: [
          {
            required: true,
            message: "近3个月的健身频率",
            trigger: ["blur", "change"],
          },
        ],
      },
      remindTitle: "风险提示",
      remindVisible: false, // 年龄限制
      remindContent: "", // 风险内容
      remindFlag: false, // 14-18显示两个按钮 14以下显示一个按钮
    };
  },
  async created() {
    await this.handleFetchFrequency();
  },
  methods: {
    handleBeforeClose(done) {
      this.submitLoading = false;
      done();
    },
    handleCloseRemind() {
      this.remindVisible = false;
      this.submitLoading = false;
    },
    handleAgree() {
      this.remindVisible = false;
      this.handlePutAddQuestion(true);
    },
    // 初始化出生年份
    handleInitYear(val) {
      if (val && !this.form.yearOfBirth) {
        this.form = { ...this.form, yearOfBirth: 1990 };
      }
    },
    // 获取健身频次选项
    handleFetchFrequency() {
      this.$Api.stores.fetchIndexDetail().then(res => {
        if (res.fitnessFrequencys && res.fitnessFrequencys.length) {
          this.frequency = [].concat(res.fitnessFrequencys);
        }
      });
    },
    // 提交按钮
    handleSubmit() {
      this.$refs["ruleForm"].validate(valid => {
        if (valid) {
          this.handleBeforeSubmit();
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    // 提交前判断年龄
    handleBeforeSubmit() {
      const age =
        Number(moment(new Date()).format("YYYY")) - this.form.yearOfBirth;
      if (age < 14) {
        this.remindFlag = false;
        this.remindVisible = true;
        this.remindContent =
          "体适能评估具有一定的运动强度，可能存在运动损伤的风险，14岁以下用户请勿体测";
      } else if (age >= 14 && age <= 18) {
        this.remindFlag = true;
        this.remindVisible = true;
        this.remindContent =
          "体适能评估具有一定的运动强度，年龄在14周岁到18周岁之间的用户请在监护人的陪同下进行体测";
      } else {
        this.handlePutAddQuestion();
      }
    },
    // 提交请求
    handlePutAddQuestion(flag) {
      this.submitLoading = true;
      this.form = {
        ...this.form,
        height: Number(this.form.height),
        weight: Number(this.form.weight),
      };
      if (flag) {
        this.form = {
          ...this.form,
          userAgreeAuthorize: [
            {
              content: this.remindContent,
              agreeAuthorize: flag,
            },
          ],
        };
      }
      this.$Api.stores
        .putAddQuestion(this.form)
        .then(res => {
          this.$message.success("提交成功!");
          setTimeout(() => {
            this.submitLoading = false;
            this.$router.push({
              path: "/stores",
              query: { navIndex: "CervixIn", id: res.id || "" },
            });
          }, 2000);
        })
        .catch(() => {
          this.submitLoading = false;
        });
    },
  },
};
</script>

<style lang="less" scoped>
.questionnaire-cont {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 49px 0 35px 0;
  .title-txt {
    margin-bottom: 50px;
    font-family: Noto Sans SC;
    font-style: normal;
    font-weight: bold;
    font-size: 24px;
    line-height: 35px;
    color: #000000;
  }
}
/deep/.questionnaire-form {
  width: 480px;
  .el-form-item {
    position: relative;
    margin-bottom: 50px;
    .el-form-item__label {
      position: absolute;
      top: -10px;
      left: 20px;
      padding: 0 10px;
      background-color: #fff;
      font-family: Noto Sans SC;
      font-style: normal;
      font-weight: normal;
      font-size: 14px;
      line-height: 20px;
      color: #494949;
      z-index: 1;
      &::before {
        display: none;
      }
    }
    &.sex-item {
      .el-form-item__label {
        top: -20px;
        left: 0;
        padding: 0;
      }
      .el-form-item__content {
        padding: 0 10px;
      }
    }
    &.is-error {
      .el-form-item__label {
        color: #f56c6c;
      }
      .el-input-group__append {
        border-color: #f56c6c;
      }
      .el-input__inner:hover + .el-input-group__append {
        border-color: #f56c6c;
        outline: 0;
      }
      .el-input__inner:focus + .el-input-group__append {
        border-color: #f56c6c;
        outline: 0;
      }
    }
  }
  .el-input__inner {
    height: 50px;
    // padding-left: 30px;
  }
  .el-input-group--append {
    width: 225px !important;
    box-sizing: border-box;
    .el-input__inner {
      padding-right: 0;
      border-right: 0;
    }
    .el-input__inner:hover + .el-input-group__append {
      border-color: #c0c4cc;
      outline: 0;
    }
    .el-input__inner:focus + .el-input-group__append {
      border-color: #1c1c1c;
      outline: 0;
    }
  }
  .el-input-group__append {
    border-left: 0px;
    background-color: #fff;
    font-family: Noto Sans SC;
    font-style: normal;
    font-weight: normal;
    font-size: 16px;
    line-height: 23px;
    color: #000000;
  }
}
.el-select-dropdown__item {
  text-align: center;
}
.flex-cont {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
}
.submit-btn {
  width: 230px;
  height: 64px;
  margin-top: 33px;
  font-family: Noto Sans SC;
  font-style: normal;
  font-weight: 500;
  font-size: 24px;
  line-height: 35px;
  color: #ffffff;
}
/deep/.checkbox-item {
  .el-form-item__content {
    line-height: inherit;
  }
}
.el-checkbox {
  font-family: Noto Sans SC;
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  line-height: 20px;
  color: #9b9b9b;
}
.remind-dialog {
  /deep/.el-dialog {
    margin-top: calc(50vh * 0.75) !important;
    width: calc(55vw * 0.75) !important;
    .el-dialog__header {
      .el-dialog__title {
        font-weight: 600;
        font-size: 18px;
      }
    }
    .remind-warpper {
      display: flex;
      .content-left {
        margin-right: 11.5px;
      }
      .content-right {
        color: #000000;
        line-height: 22px;
      }
    }
  }
}
</style>
